import { useCallback } from "react";

import { useFiltersContext } from "domain/Filters";
import ReactPaginate from "react-paginate";
import { ArrowLeft, ArrowRight } from "assets";
import clsx from "clsx";

import "./items-table-pagination.scss";
import { useSearchParams } from "react-router-dom";

const constants = {
  PAGE_SIZES: [100, 50, 30, 10],
  PREV_LABEL: "Prethodna",
  NEXT_LABEL: "Sledeća",
  PAGE: "strana",
  BREAK_LABEL: "...",
};

export const ItemsTablePagination = ({ pageCount, pageIndex = 0, gotoPage, marginPages = 1, pageRange = 3 }) => {
  const isUrlDriven = !gotoPage;
  const { itemsPerView, setItemsPerView } = useFiltersContext();
  const [searchParams, setSearchParams] = useSearchParams();

  const currentPage = isUrlDriven ? parseInt(searchParams.get("page") || "1", 10) : pageIndex + 1;
  const pageSize = isUrlDriven ? parseInt(searchParams.get("pageSize") || "30", 10) : itemsPerView;

  const handlePageClick = useCallback(
    (event) => {
      if (isUrlDriven) {
        const newPage = event.selected + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set("page", newPage.toString());
        setSearchParams(newParams);
      } else {
        gotoPage(event.selected);
      }
    },
    [gotoPage, isUrlDriven, searchParams, setSearchParams]
  );

  const handlePageSizeChange = useCallback(
    (newSize) => {
      if (isUrlDriven) {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("pageSize", newSize.toString());
        newParams.set("page", "1");
        setSearchParams(newParams);
      } else {
        setItemsPerView(newSize);
      }
    },
    [isUrlDriven, setItemsPerView, searchParams, setSearchParams]
  );

  return (
    <div className="pagination">
      <ReactPaginate
        activeClassName="pagination__number--active"
        breakClassName="pagination__item pagination__item--break"
        breakLabel={constants.BREAK_LABEL}
        breakLinkClassName="pagination__item-link pagination__item-link--break"
        containerClassName="pagination__controls"
        disableInitialCallback
        disabledClassName="pagination__item--disabled"
        forcePage={currentPage - 1}
        marginPagesDisplayed={marginPages}
        nextAriaLabel={`${constants.NEXT_LABEL} ${constants.PAGE}`}
        nextClassName="pagination__item pagination__item--next"
        nextLinkClassName="pagination__button pagination__button--next"
        onPageChange={handlePageClick}
        pageClassName="pagination__item"
        pageCount={pageCount}
        pageLinkClassName="pagination__item-link"
        pageRangeDisplayed={pageRange}
        previousAriaLabel={`${constants.PREV_LABEL} ${constants.PAGE}`}
        previousClassName="pagination__item pagination__item--previous"
        previousLinkClassName="pagination__button pagination__button--prev"
        renderOnZeroPageCount={null}
        nextLabel={
          <>
            <span>{constants.NEXT_LABEL}</span>
            <ArrowRight />
          </>
        }
        previousLabel={
          <>
            <ArrowLeft />
            <span>{constants.PREV_LABEL}</span>
          </>
        }
      />
      <div className="pagination__page-count">
        {`Prikaži `}
        {constants.PAGE_SIZES.map((value, i) => {
          return (
            <button
              key={i}
              className={clsx("pagination__page-count-item", {
                "pagination__page-count-item--active": pageSize === value,
              })}
              onClick={() => handlePageSizeChange(value)}
            >
              {value}
            </button>
          );
        })}
        {` rezultata`}
      </div>
    </div>
  );
};